export const CLASS_NAME = 'cst-fluid-content-wrapper'
export const HORIZONTAL_PADDING = 200
